import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import React, { useState } from 'react'

import { ChevronLeftIcon, ChevronRightIcon } from '../../../icons'
import Typography from '../../atoms/typography'
import BasicCalendar, { BasicCalendarProps } from '../basic-calendar'
import { YearlyCalendarEvent } from './types'
type YearlyCalendarProps = Omit<BasicCalendarProps, 'header' | 'month'> & {
  events: YearlyCalendarEvent[]
  headerActions?: React.ReactNode
}

const YearlyCalendar: React.FC<YearlyCalendarProps> = (props) => {
  const [year, setYear] = useState(new Date().getFullYear())
  return (
    <div className="bg-white-hover border border-grey-light rounded-xl overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-grey-light bg-white">
        <Typography variant="sub-heading" className="flex-1">
          {DateFormatter.DDDMYYYY(new Date())}
        </Typography>
        <div className="flex items-center justify-between w-32">
          <div className="cursor-pointer border border-grey-light rounded p-1">
            <ChevronLeftIcon
              color={tailwindColors.grey.DEFAULT}
              onClick={() => setYear(year - 1)}
            />
          </div>
          <Typography variant="body-medium">{year}</Typography>
          <div className="cursor-pointer border border-grey-light rounded p-1">
            <ChevronRightIcon
              color={tailwindColors.grey.DEFAULT}
              onClick={() => setYear(year + 1)}
            />
          </div>
        </div>
        <div className="flex-1  flex justify-end gap-2">{props.headerActions}</div>
      </div>
      <div className="grid grid-cols-3 gap-4 p-4">
        {Array.from({ length: 12 }, (_, i) => i).map((month) => (
          <BasicCalendar
            key={month}
            disabledDates={props.disabledDates}
            className="py-2 border border-grey-light  rounded-xl"
            year={year}
            month={month}
            header={(data) => (
              <div className="flex items-center justify-center pb-2 border-b border-grey-light">
                <Typography variant="tag">{data.month}</Typography>
              </div>
            )}
            {...props}
          />
        ))}
      </div>
    </div>
  )
}

export default YearlyCalendar
